<template>
  <v-container>
    <div class="search">
      <v-row
        no-gutters
        justify="center"
        style="color: red"
      >
        Camping
      </v-row>
      <v-row
        no-gutters
        justify="center"
      >
        <h2>營地搜尋結果</h2>
      </v-row>
      <DatePickerSearch
        class="px-12"
        :is-fast="false"
        @getDate="getDate"
      />
    </div>
    <div
      v-for="(area, i) in campingList"
      :key="i"
    >
      <v-row
        no-gutters
        justify="center"
        class="mt-7 mb-7"
      >
        <h2>{{ area.areaName }}</h2>
      </v-row>
      <v-row
        align="center"
      >
        <v-col
          v-for="(item, i) in area.accountInfo"
          :key="i"
          cols="12"
          sm="6"
        >
          <v-row no-gutters>
            <v-col
              cols="3"
            >
              <v-img
                class="ma-0 mr-3"
                aspect-ratio="1"
                :src="item.img"
              />
            </v-col>
            <v-col
              cols="9"
              class="text-left"
            >
              <div class="d-flex align-center mb-2">
                <div
                  class="font-weight-bold"
                  style="font-size: 20px"
                >
                  {{ item.accountName }}
                </div>
                <v-spacer />
                <v-btn
                  color="primary"
                  elevation="0"
                  :disabled="item.status === 0"
                  class="font-weight-bold"
                  dens
                  rounded
                  @click="
                    $router.push(`/Booking/1/${searchDate}/${item.accountId}`)
                  "
                >
                  {{ item.status === 0 ? "已額滿" : "我要訂" }}
                </v-btn>
              </div>
              <div>{{ item.address }}</div>
              <div>{{ item.mobile }}</div>
            </v-col>
            <v-col
              cols="12"
              class="campListDivider"
            >
              <v-divider class="my-3" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import DatePickerSearch from '/src/components/DatePickerSearch.vue'

export default {
  components: {
    DatePickerSearch
  },
  data () {
    return {
      campingList: [
        {
          areaId: '01',
          areaName: '東部',
          accountInfo: [
            {
              img: 'https://picsum.photos/500/300?image=16',
              accountId: '1',
              accountName: '不想回家',
              address: '台東縣',
              mobile: '0965-507-555',
              status: 1
            },
            {
              img: 'https://picsum.photos/500/300?image=19',
              accountId: '2',
              accountName: '花間露',
              address: '宜蘭縣',
              mobile: '0965-507-555',
              status: 0
            }
          ]
        },
        {
          areaId: '02',
          areaName: '北部',
          accountInfo: [
            {
              accountId: '3',
              accountName: '不想回家',
              address: '基隆',
              img: 'https://picsum.photos/500/300?image=22',
              mobile: '0965-507-555',
              status: 1
            },
            {
              accountId: '4',
              accountName: '花間露',
              address: '新北市',
              img: 'https://picsum.photos/500/300?image=12',
              mobile: '0965-507-555',
              status: 0
            }
          ]
        }
      ],
      searchDate: null
    }
  },

  methods: {
    getDate (val) {
      this.searchDate = val
    }
  }
}
</script>

<style scoped>
@media screen and (min-width: 600px) {

  .campListDivider{
    display: none;
  }
}
.search {
  /* background: radial-gradient(ellipse at top left, rgba(105,155,200,1) 0%,rgba(181,197,216,1) 57%); */
}
</style>
